module.exports = __webpack_public_path__ + "static/media/AlwynNewRounded_Regular_Italic.da46934e.woff";